import { Component, OnDestroy, OnInit, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Subscription } from 'rxjs';
import { NotificationService } from './services/notification.service';
import { Notification } from './dto/notification.dto';

@Component({
  selector: 'app-notification',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './notification.component.html',
  styleUrls: ['./notification.component.scss'],
})
export class NotificationsComponent implements OnInit, OnDestroy {
  private readonly notificationService = inject(NotificationService);
  private subscription = new Subscription();

  notifications: Notification[] = [];

  ngOnInit(): void {
    this.subscription.add(
      this.notificationService.getNotifications$.subscribe((notifications) => {
        this.notifications = notifications;
      })
    );
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  closeNotification(id: string | number): void {
    const element = document.getElementById(`notification-${id}`);

    if (element) {
      element.classList.add('fade-out');

      setTimeout(() => {
        this.notificationService.removeNotification(id);
      }, 700);
    } else {
      this.notificationService.removeNotification(id);
    }
  }

  clearNotifications(): void {
    this.notificationService.clearNotifications();
  }

  isArray(value: any): value is string[] {
    return Array.isArray(value);
  }
}
